/* Marquee scroll-velocity FX — leans (skews) the marquee with scroll speed, then
   eases back. Applies an identical skew to EVERY .marquee__content copy (the
   theme clones one for the seamless loop), and adds NO translate — so the loop
   math and the clones stay perfectly in sync. Skips reduced-motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var hosts = [];

  function scan() {
    var comps = document.querySelectorAll('marquee-component');
    for (var i = 0; i < comps.length; i++) {
      if (!comps[i].__mqfx) {
        comps[i].__mqfx = true;
        hosts.push(comps[i]);
      }
    }
  }
  scan();
  document.addEventListener('shopify:section:load', scan);

  var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var vel = 0;
  var applied = 0; // last skew written (to avoid redundant writes)

  window.addEventListener('scroll', function () {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    vel += y - lastY;
    lastY = y;
    if (vel > 140) vel = 140;
    if (vel < -140) vel = -140;
  }, { passive: true });

  function setSkew(deg) {
    var t = deg === 0 ? '' : 'skewX(' + deg.toFixed(2) + 'deg)';
    for (var i = 0; i < hosts.length; i++) {
      var contents = hosts[i].querySelectorAll('.marquee__content');
      for (var j = 0; j < contents.length; j++) contents[j].style.transform = t;
    }
    applied = deg;
  }

  (function loop() {
    vel *= 0.86;
    if (Math.abs(vel) < 0.05) vel = 0;
    var skew = Math.max(-6, Math.min(6, vel * 0.09));
    skew = Math.round(skew * 100) / 100;
    if (skew !== applied) setSkew(skew);
    requestAnimationFrame(loop);
  })();
})();
